import React from 'react'
import PropTypes from 'prop-types'

import { Tabs, Tab } from '@cred/react-tabs'
import { tabClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'

import ExpDashboard from '../dashboard/App'
import { CashOutError, ValidationsError } from '../error-pages'
import RatesTableTooltip from '../rates-table-tooltip/RatesTableTooltip'
import styles from './styles.module.scss'

const tabsIndexes = {
  'top-rates': 0,
  'all-rates': 1,
  getByIndex: (index) => {
    return Object.keys(tabsIndexes).find((key) => tabsIndexes[key] === index)
  },
}

const TabsForm = (props) => {
  const {
    activeTab,
    onGetStarted,
    error,
    loading,
    bestProducts,
    allProducts,
    purchaseLenderCentricProductsSorted,
    isFullTable,
    analyticsContexts,
    paginationProps,
    isCashOutError,
    isValidationsError,
    isPurchase,
    trackSnowplowEvent,
    onTabChange,
    sortingForm,
  } = props

  const tabTilesCount = error ? 0 : bestProducts.length
  const purchaseLenderCentricProductsSortedCount = error
    ? 0
    : purchaseLenderCentricProductsSorted?.length

  const refinanceTabName = (
    <div className={styles.refinanceFirstTab}>
      {`Top Rates (${tabTilesCount})`}
      <RatesTableTooltip
        interactive
        contentClassName={styles.refinanceFirstTabContent}
        triggerClassName={styles.refinanceTabTooltipTrigger}
        placement="bottom"
      >
        <p className={`${styles.tooltipText} disclaimer`} id="topRateTooltip">
          Top rates: After comparing our lenders’ pricing for today, we’ve pulled the option with
          the lowest points associated with each interest rate. To see all rates from our lenders,
          click on “All rates”
        </p>
      </RatesTableTooltip>
    </div>
  )
  const tabTitleList = [
    isPurchase ? `Lenders’ Best (${purchaseLenderCentricProductsSortedCount})` : refinanceTabName,
    `All Rates (${error ? 0 : allProducts.length})`,
  ]

  const onTabClick = (index) => {
    onTabChange(tabsIndexes.getByIndex(index))
    trackSnowplowEvent(
      tabClick,
      {
        text: tabTitleList[index],
      },
      [...analyticsContexts],
    )
  }

  return (
    <div className={styles.container}>
      {isCashOutError && <CashOutError />}
      {isValidationsError && !isCashOutError && <ValidationsError isPurchase={isPurchase} />}
      {!isCashOutError && !isValidationsError && (
        <Tabs
          activeTab={tabsIndexes[activeTab]}
          type="flat"
          onTabClick={onTabClick}
          branding={{
            tabHeader: 'tab-header',
            tabContent: 'tab-content',
            tabItem: 'tab-item',
            tabItemWrapper: 'tab-item-wrapper',
            tabActive: 'tab-active',
          }}
        >
          <Tab title={<span>{tabTitleList[0]}</span>}>
            <ExpDashboard
              onGetStarted={onGetStarted}
              error={error}
              loading={loading}
              products={isPurchase ? purchaseLenderCentricProductsSorted : bestProducts}
              isFullTable={isFullTable}
              analyticsContexts={analyticsContexts}
              paginationProps={paginationProps}
            />
          </Tab>
          <Tab title={<span>{tabTitleList[1]}</span>}>
            <ExpDashboard
              onGetStarted={onGetStarted}
              error={error}
              loading={loading}
              products={allProducts}
              isFullTable={isFullTable}
              analyticsContexts={analyticsContexts}
              paginationProps={paginationProps}
            />
          </Tab>
        </Tabs>
      )}
      {sortingForm ? (
        <div className={styles.sortingFormWrapper}>
          <div className={styles.sortingFormContainer}>
            <p className={`${styles.sortingFormLabel} bodySmall neutral500`}>Order by:</p>
            {sortingForm}
          </div>
        </div>
      ) : null}
    </div>
  )
}
TabsForm.propTypes = {
  isFullTable: PropTypes.bool.isRequired,
  onGetStarted: PropTypes.func.isRequired,
  analyticsContexts: PropTypes.array,
  error: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  bestProducts: PropTypes.array.isRequired,
  activeTab: PropTypes.string.isRequired,
  allProducts: PropTypes.array.isRequired,
  paginationProps: PropTypes.object.isRequired,
  isCashOutError: PropTypes.bool.isRequired,
  isValidationsError: PropTypes.bool.isRequired,
  isPurchase: PropTypes.bool.isRequired,
  trackSnowplowEvent: PropTypes.func.isRequired,
  onTabChange: PropTypes.func.isRequired,
  sortingForm: PropTypes.element.isRequired,
  purchaseLenderCentricProductsSorted: PropTypes.array.isRequired,
}

export default withSnowplowContexts(TabsForm)
